import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RndIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_562_1772)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16.875 16.3147C16.875 16.6131 16.7565 16.8992 16.5455 17.1102C16.3345 17.3212 16.0484 17.4397 15.75 17.4397H2.25C1.95163 17.4397 1.66548 17.3212 1.4545 17.1102C1.24353 16.8992 1.125 16.6131 1.125 16.3147V1.6897C1.125 1.39133 1.24353 1.10518 1.4545 0.894202C1.66548 0.683224 1.95163 0.564697 2.25 0.564697H13.5338C13.8275 0.564732 14.1096 0.67967 14.3198 0.884947L16.536 3.04645C16.6434 3.15131 16.7287 3.2766 16.7869 3.41493C16.8451 3.55327 16.8751 3.70186 16.875 3.85195V16.3147Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.7212 6.7522L13.5337 9.5647L10.7212 12.3772",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.34619 6.7522L4.53369 9.5647L7.34619 12.3772",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_562_1772",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
